$ = jQuery;
var $container,
    loading = false;

$(function() {

	if ( typeof selected_items != 'undefined' && selected_items ) {
		prevSelectFilters();
	}
	if ( typeof search_items != 'undefined' && search_items != '' ) {
		prevSearchFilters();
	}
	selectFilter();

    if($('.load_more').parent().find('.items').length>0)
    {

        $(window).scroll(function() {
            if($('.load_more').length>0)
            {
        		$container = $('.load_more').parent().find('.items');
            	var pos = $(window).scrollTop();
                var trigger = $(document).height() - $(window).height() - ( 2 * $('#frame_bottom').height() );
				if (pos >= trigger && loading === false) {
					scroll_loader( $container );
				}
			}
        });
    }

    $('.cursussen .filter .row ul li a').click(function(){
    	if(loading===false)
    	{
	    	var tax_query = {};
	    	$(this).closest('.filter').find('li a.active').each(function(){
	    		var cl = $(this).closest('div').attr('class');

	    		if(tax_query[cl]==undefined)
	    			tax_query[cl] = [];

	    		var c = tax_query[cl] != undefined && cl == 'schedule' ? tax_query[cl].length : 0;

	    		tax_query[cl][c] = $(this).data('term_id');
	    	});

	    	$container = $(this).closest('.overzicht').find('.items');

	    	$container.stop().animate({'opacity':0},800,function(){
	    		var $this = $(this).clone();
	    		var $obj = Object.keys(tax_query).length>0 ? JSON.stringify(tax_query) : '';
	    		var query_str = '?';
	    		for (var k in tax_query) {
	    			if ( query_str != '?' ) {
	    				query_str += '&';
	    			}
	    			if ( k == 'discipline' ) {
	    				query_str += 'disciplines=';
	    			}
	    			if ( k == 'schedule' ) {
	    				query_str += 'dag=';
	    			}
	    			if ( k == 'age' ) {
	    				query_str += 'voor-wie=';
	    			}
	    			if ( k == 'location' ) {
	    				query_str += 'locatie=';
	    			}
	    			if ( k == 'level' ) {
	    				query_str += 'niveau=';
	    			}
	    			if ( k == 'coursetype' ) {
	    				query_str += 'soort=';
	    			}
	    			for ( var i = 0; i < tax_query[k].length; i++ ) {
	    				query_str += tax_query[k][i];
	    				if ( i != tax_query[k].length-1 ) {
	    					query_str += ',';
	    				}
	    			}
	    		}
	    		history.pushState({}, "", query_str);
	    		$(this).remove();
	    		$this.attr('data-tax', $obj ).html('').removeAttr('style');
	    		$('.overzicht .center .clear').before( $this );
	    		scroll_loader( $this );
	    	});
    	}
    	return false;
    });

    $('.filter .trefwoord').keyup(function(){
    	if(loading===false)
    	{
	    	var $query = $(this).val();
	    	if($query.length>=3 || $query.length==0)
	    	{
	    		$container = $(this).closest('.overzicht').find('.items');
	    		$container.stop().animate({'opacity':0},800,function(){
		    		var $this = $(this).clone();
		    		$this.html('').removeAttr('style');
		    		$(this).remove();
		    		$('.overzicht .center .clear').before( $this );
		    		history.pushState({}, "", '?zoek=' + $query);
		    		scroll_loader( $this, $query );
		    	});
	    	}
    	}
    	return false;
    });

    $('.filter-slided-up .close-trefwoord,.filter-slided-down .close').click(function(){
    	var $reload = false;

	    $container = $(this).closest('.overzicht').find('.items');
    	if($container.data('tax').toString()!='')
    		$reload = true;
    	if($(this).closest('.filter').find('input').val().length>0)
    		$reload = true;

    	if($reload){
	    	$(this).closest('.filter-slided-down').find('.row ul li a').removeClass('active');
	    	$(this).closest('.filter').find('input').val('');

			$container.stop().animate({'opacity':0},800,function(){
	    		var $this = $(this).clone();
	    		$this.attr('data-tax','').html('').removeAttr('style');
	    		$(this).remove();
	    		$('.overzicht .center .clear').before( $this );
	    		scroll_loader( $this );
	    	});
	    }
    });

});

function prevSearchFilters() {
	var $filterSlidedUp = $('.filter-slided-up'), $closeButton = $filterSlidedUp.find('.close-trefwoord'), centerWidth = $filterSlidedUp.parents('.center').width(), closeButtonWidth = $closeButton.outerWidth();
	$('.filter-slided-up').find('input.trefwoord').val(search_items).keyup();
	animating_filter = true;
	$filterSlidedUp.find('em').addClass('hide');
	$filterSlidedUp.find('button').addClass('hide');
	setTimeout(function() {
		$('.input-trefwoord').css({
			'width' : centerWidth - closeButtonWidth - 12
		}).addClass('wide');
	}, 300);
	setTimeout(function() {
		$closeButton.css({
			'opacity' : 1
		});
		animating_filter = false;
	}, 500);
	if(loading===false)
	{
    	var $query = $('.filter-slided-up').find('input.trefwoord').val();
    	if($query.length>=3 || $query.length==0)
    	{
    		$container = $('.filter-slided-up').find('input.trefwoord').closest('.overzicht').find('.items');
    		$container.stop().animate({'opacity':0},800,function(){
	    		var $this = $(this).clone();
	    		$this.html('').removeAttr('style');
	    		$(this).remove();
	    		$('.overzicht .center .clear').before( $this );
	    		scroll_loader( $this, $query );
	    	});
    	}
	}
}

function prevSelectFilters() {
	$container = $('.overzicht .items');
	if ( selected_genres ) {
		if( $('.filter .zakelijk button[data-value="' + selected_genres + '"]').length > 0 ) {
			$('.filter .zakelijk button[data-value="' + selected_genres + '"]').click();
		}
	}else{
		$('.filter button', '.overzicht').click();
		if ( selected_discipline ) {
			$('.filter .discipline li a[data-term_id="' + selected_discipline + '"]').addClass('active');
		}
		if ( selected_day ) {
			for ( var i = 0; i < selected_day.length; i++ ) {
				$('.filter .schedule li a[data-term_id="' + selected_day[i] + '"]').addClass('active');
			}
		}
		if ( selected_age ) {
			$('.filter .age li a[data-term_id="' + selected_age + '"]').addClass('active');
		}
		if ( selected_location ) {
			$('.filter .location li a[data-term_id="' + selected_location + '"]').addClass('active');
		}
		if ( selected_level ) {
			$('.filter .level li a[data-term_id="' + selected_level + '"]').addClass('active');
		}
		if ( selected_type ) {
			$('.filter .coursetype li a[data-term_id="' + selected_type + '"]').addClass('active');
		}

		var tax_query = {};
		$('.filter').find('li a.active').each(function(){
			var cl = $(this).closest('div').attr('class');

			if(tax_query[cl]==undefined)
				tax_query[cl] = [];

			var c = tax_query[cl] != undefined && cl == 'schedule' ? tax_query[cl].length : 0;

			tax_query[cl][c] = $(this).data('term_id');
		});

		$container.stop().animate({'opacity':0},800,function(){
			var $this = $(this).clone();
			var $obj = Object.keys(tax_query).length>0 ? JSON.stringify(tax_query) : '';
			$(this).remove();
			$this.attr('data-tax', $obj ).html('').removeAttr('style');
			$('.overzicht .center .clear').before( $this );
			scroll_loader( $this );
		});
	}
}

function selectFilter() {
	var $filterSlidedDown = $('.filter-slided-down');
	if ( $filterSlidedDown.length > 0 ) {
		$('a', '.filter-slided-down ul').on('click', function() {
			if(loading===false)
			{
				var mode = 'enable';
				if($(this).is('.active'))
					mode = 'disable';

				if($(this).closest('div').is(':not(.schedule)'))
					$(this).closest('div').find('li a').removeClass('active');
				if(mode=='disable')
					$(this).removeClass('active');
				else
					$(this).addClass('active');
			}
			return false;
		});
	}
}

function scroll_loader( e, q ){
    loading = true;

    $('.load_more').animate({'opacity' : 1},500);

    $order = e.data('order');

    $.ajax({
        type : 'POST',
        dataType : 'json',
        url : js_object.ajax_url,
        data : {
            'action'    : 'ajaxloader',
            'paged'     : e.data('paged'),
            'limit'     : e.data('limit'),
            'order'     : $order,
            'orderby'   : e.data('orderby'),
            'tax'		: e.data('tax'),
            'type'      : e.data('type'),
            's'			: q,
            'exclude'   : e.find('.item').map(function(){ return $(this).data('id') }).get().join(',')
                + (e.data('exclude')?','+e.data('exclude'):'')
        },
        success : function(data) {

            if(data.html !==false)
            {
                $.when( ( $order == 'DESC' ? e.prepend( data.html ) : e.append( data.html ) ) ).then(function(e){
                    loading = false;
                    change_counter(e);
                    $('.load_more').animate({'opacity' : 0},500);
                    e.find('.item.new').animate({'opacity' : 1},500).removeClass('new');

                    $(e).find('.icon').each(function() {
						if($(this).find('svg').length==0)
						{
							var box = this;
							$(box).parent().show();
							if ($(box).data('id') != undefined) {
								var iconId = $(box).data('id');
								initIcon(box, iconId);
							}
						}
					});

                });

            }else{
            	change_counter(e);
                $.when( $('.load_more').animate({'opacity' : 0},500,function(){ $(this).find('span').text( data.message ) }) ).then(function(){
                    $('.load_more').animate({'opacity' : 1},500);
                    loading = false;

                    setTimeout(function(){
                        $('.load_more').animate({'opacity' : 0},500,function(){
                            $(this).remove();
                        });
                    },1500);
                });
            }
        }
    });
 }

function change_counter(e) {
	var count = e.find('.item').length,
		$total = e.closest('.results').find('.total');
	if($total.find('span').text()!=count)
	{
    	$total.prepend('<span class="new">' + count + '</span>');
    	setTimeout(function(){
    		$total.find('.new').removeClass('new');
    		$total.find('span:last').remove();
    		if(count==1)
        		$total.removeClass('multi');
        	else
        		$total.addClass('multi');
    	},250);
	}
}
